// convert {Person.FieldName} or {Site.FieldName} to [#FieldName]
export const encodeRecipientPlaceholders = (text = "") => {
  if (!text) return "";
  return text.replace(/\{(?:Person|Site)\.([A-Za-z0-9_]+)\}/g, (_, field) => `[#${field}]`);
};

// convert [#FieldName] to {recipientType.FieldName}
export const decodeRecipientPlaceholders = (text, recipientType) => {
  if (!text || !recipientType) return "";

  return text.replace(/\[#([A-Za-z0-9_]+)\]/g, (match, key) => {
    return `{${recipientType}.${key}}`;
  });
};
